import Button from '../../shared/buttons/button';
import ConfirmModal from '../../shared/modals/confirm-modal';
import { useBooleanState } from '../../../hooks/index/use-boolean-state';
import { useLogoutMutation } from '../../../hooks/react-query/use-auth';

type LogoutButtonProps = {
  isLoading: boolean;
  isDisabled: boolean;
};

function LogoutButton({ isLoading, isDisabled }: LogoutButtonProps) {
  const { value: showModal, toggle: toggleShowModal } = useBooleanState(false);
  const { mutate: logoutUser } = useLogoutMutation();

  return (
    <>
      {showModal && (
        <ConfirmModal
          showModal={showModal}
          content='آیا از خروج خود مطمئن هستید؟'
          onConfirm={() => {
            logoutUser();
            toggleShowModal();
          }}
          onCancel={toggleShowModal}
        />
      )}
      <Button
        content='خروج'
        color='red'
        colorWeight={500}
        onClick={toggleShowModal}
        loading={isLoading}
        disabled={isDisabled}
      />
    </>
  );
}

export default LogoutButton;
